import { LoadingButton } from "@mui/lab";
import { DialogActions, DialogContent, Typography } from "@mui/material";
import { useForm as useFormController } from "react-hook-form";

import { Form, RadioSelect } from "@/base";
import { EmergencyImportMode, formatEmergencyImportMode } from "@/enums";

const EmergencyImportDialogModeSelectionStepContent = ({ defaultFormData, onNext }) => {
    const formController = useFormController({
        defaultValues: defaultFormData,
    });

    const handleFormSubmit = (data) => {
        onNext(data);
    };

    return (
        <Form formController={formController} onSubmit={handleFormSubmit}>
            <DialogContent sx={{ pt: 3 }}>
                <Typography variant="body1" sx={{ mb: 3 }}>
                    Wählen Sie aus, wie die Ergebnisse den Teilnehmern zugeordnet werden sollen:
                </Typography>
                <RadioSelect
                    control={formController.control}
                    name="importMode"
                    label="Zuordnungsmodus"
                    options={[
                        {
                            value: EmergencyImportMode.BY_PARTICIPANT_ID,
                            label: formatEmergencyImportMode(EmergencyImportMode.BY_PARTICIPANT_ID),
                            description: "Ordnet Ergebnisse anhand der eindeutigen Teilnehmer-ID zu",
                        },
                        {
                            value: EmergencyImportMode.BY_PARTICIPANT_NAME,
                            label: formatEmergencyImportMode(EmergencyImportMode.BY_PARTICIPANT_NAME),
                            description: "Ordnet Ergebnisse anhand des Teilnehmernamens zu",
                        },
                    ]}
                    rules={{
                        required: "Bitte wählen Sie einen Zuordnungsmodus aus",
                    }}
                />
            </DialogContent>
            <DialogActions>
                <LoadingButton type="submit" variant="contained">
                    Weiter
                </LoadingButton>
            </DialogActions>
        </Form>
    );
};

export { EmergencyImportDialogModeSelectionStepContent };